import styled from "styled-components";
import {colors, sizes, fontSize} from "../../../themes";

export const SelectWrapper = styled.div`
  position: relative;
  box-sizing: border-box;
  width: 100%;
  select {
    display: none;
  }
  ${props => props.disabled && 'opacity: 0.6; pointer-events: none;'}
`;

export const Selected = styled.div`
  width: 100%;
  box-sizing: border-box;
  background-color: ${colors.background.white};
  border: 1px solid ${props => props.error ? colors.border.burntSienna : colors.border.silver};
  border-radius: 4px;
  padding: 8px 12px 8px 8px;
  font-style: normal;
  font-weight: 700;
  ${fontSize(14)}
  line-height: 140%;
  color: ${colors.text.ebony};
  cursor: pointer;
  user-select: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  img {
    height: 24px;
    opacity: ${props => props.empty ? 0.12 : 1};
    transform: rotate(${props => props.opened? 180 : 0}deg);
    transition: all 0.3s ease-in-out;
  }
  input {
    width: 100%;
    outline: none;
    font-style: normal;
    font-weight: 700;
    ${fontSize(14)}
    line-height: 140%;
    color: ${colors.text.ebony};
    border: none;
    ::placeholder {
      font-style: normal;
      font-weight: 700;
      ${fontSize(14)}
      line-height: 140%;
      color: ${colors.text.ebony};
    }
  }
  @media only screen and ${sizes.max991} {
    padding: 1.6vw 2.4vw 1.6vw 1.6vw;
    img {
      height: 4.8vw;
    }
  }
`;

export const Options = styled.div`
  position: absolute;
  box-sizing: border-box;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 99;
  background: #FFFFFF;
  border: 1px solid #BDBDBD;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  padding-top: 5px;
  padding-bottom: 5px;
  max-height: 20vh;
  overflow-y: auto;
  ${props =>( !props.opened || props.disabled )&& 'display: none;'}
  ${fontSize(14)}
  @media only screen and ${sizes.max991} {
    padding-top: 1vw;
    padding-bottom: 1vw;
  }
`;

export const Option = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
  font-style: normal;
  font-weight: ${props=>props.isNewOption? '800': '400'};
  font-size: 14px;
  line-height: 140%;
  color: ${colors.text.ebony};
  cursor: pointer;
  user-select: none;
  color: ${props=> props.isNewOption? colors.text.blue: props.selected ? colors.text.kleinBlue : colors.text.ebony} ;
  background-color: ${props => props.selected ? colors.background.linkWater : colors.background.white};
  :hover {
    background-color: ${colors.background.linkWater};
  }
`;
